












import { Component, Mixins } from 'vue-property-decorator';
import { View } from 'client-website-ts-library/plugins';
import { BlogFilter, BlogOrderBy } from 'client-website-ts-library/filters';
import { WebsiteLevel } from 'client-website-ts-library/types';

import { Config } from 'client-website-ts-library/services';
import Blogs from '../components/Blogs.vue';

@Component({
  components: {
    Blogs,
  },
})
export default class Blog extends Mixins(View) {
  private filter = new BlogFilter({
    SearchLevel: WebsiteLevel.Profile,
    SearchGuid: Config.Website.Settings!.WebsiteId,
    OrderByStatements: [BlogOrderBy.CreateDateDesc],
  });
}
